"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _IconX = _interopRequireDefault(require("@instructure/ui-icons/lib/Solid/IconX"));

var _View = _interopRequireDefault(require("@instructure/ui-layout/lib/components/View"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _ThemeablePropTypes = _interopRequireDefault(require("@instructure/ui-themeable/lib/utils/ThemeablePropTypes"));

var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");

var _isActiveElement = _interopRequireDefault(require("@instructure/ui-utils/lib/dom/isActiveElement"));

var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _dec2, _class, _class2, _temp;

var styles = {
  componentId: 'dmMja',
  template: function template(theme) {
    return "\n\n.dmMja_bGBk{-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;align-items:center;box-sizing:border-box;display:inline-flex;font-family:".concat(theme.fontFamily || 'inherit', ";text-align:center;user-select:none;vertical-align:middle}\n\n[dir=ltr] .dmMja_bGBk,[dir=rtl] .dmMja_bGBk{text-align:center}\n\n.dmMja_doqw{font-size:").concat(theme.fontSizeSmall || 'inherit', ";height:").concat(theme.heightSmall || 'inherit', ";padding:").concat(theme.paddingSmall || 'inherit', "}\n\n.dmMja_doqw .dmMja_dnnz{font-size:0.75rem}\n\n.dmMja_ycrn{font-size:calc(").concat(theme.fontSizeMedium || 'inherit', " - 0.0625rem);height:").concat(theme.heightMedium || 'inherit', ";padding:").concat(theme.padding || 'inherit', "}\n\n.dmMja_ycrn .dmMja_dnnz{font-size:0.75rem}\n\n.dmMja_cMDj{font-size:calc(").concat(theme.fontSizeLarge || 'inherit', " - 0.0625rem);height:").concat(theme.heightLarge || 'inherit', ";padding:").concat(theme.padding || 'inherit', "}\n\n.dmMja_cMDj .dmMja_dnnz{font-size:0.875rem}\n\n.dmMja_EwaR{outline:none;overflow:visible;position:relative;touch-action:manipulation;transition:background-color ").concat(theme.transitionTiming || 'inherit', "}\n\n.dmMja_EwaR:before{border:").concat(theme.focusOutlineWidth || 'inherit', " ").concat(theme.focusOutlineStyle || 'inherit', " ").concat(theme.focusOutlineColor || 'inherit', ";border-radius:").concat(theme.borderRadius || 'inherit', ";bottom:-0.3125rem;box-sizing:border-box;content:\"\";left:-0.3125rem;opacity:0;pointer-events:none;position:absolute;right:-0.3125rem;top:-0.3125rem;transform:scale(0.9);transition:all ").concat(theme.transitionTiming || 'inherit', "}\n\n.dmMja_EwaR:not(.dmMja_erdA){cursor:pointer}\n\n.dmMja_EwaR:focus:before{opacity:1;transform:scale(1)}\n\n.dmMja_EwaR.dmMja_ywdX{cursor:not-allowed;opacity:0.5;pointer-events:none}\n\n.dmMja_dnnz{-webkit-margin-end:0;-webkit-margin-start:").concat(theme.iconMargin || 'inherit', ";cursor:pointer;margin-inline-end:0;margin-inline-start:").concat(theme.iconMargin || 'inherit', ";transform:translateY(0.0625rem);transition:all ").concat(theme.transitionTiming || 'inherit', "}\n\n[dir=ltr] .dmMja_dnnz{margin-left:").concat(theme.iconMargin || 'inherit', ";margin-right:0}\n\n[dir=rtl] .dmMja_dnnz{margin-left:0;margin-right:").concat(theme.iconMargin || 'inherit', "}\n\n.dmMja_eWKC{max-width:").concat(theme.maxWidth || 'inherit', ";overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\n\n.dmMja_ddES{background-color:").concat(theme.defaultBackground || 'inherit', ";border:").concat(theme.defaultBorderWidth || 'inherit', " ").concat(theme.defaultBorderStyle || 'inherit', " ").concat(theme.defaultBorderColor || 'inherit', ";border-radius:").concat(theme.defaultBorderRadius || 'inherit', ";color:").concat(theme.defaultColor || 'inherit', "}\n\n.dmMja_ddES.dmMja_EwaR:before{border-radius:").concat(theme.defaultBorderRadius || 'inherit', "}\n\n.dmMja_ddES.dmMja_EwaR:hover{background-color:").concat(theme.defaultBackgroundHover || 'inherit', "}\n\n.dmMja_ddES.dmMja_erdA .dmMja_dnnz{color:").concat(theme.defaultIconColor || 'inherit', "}\n\n.dmMja_ddES.dmMja_erdA:hover .dmMja_dnnz{color:").concat(theme.defaultIconHoverColor || 'inherit', "}\n\n.dmMja_eXrk{background-color:").concat(theme.inlineBackground || 'inherit', ";border:").concat(theme.inlineBorderWidth || 'inherit', " ").concat(theme.inlineBorderStyle || 'inherit', " ").concat(theme.inlineBorderColor || 'inherit', ";border-radius:").concat(theme.inlineBorderRadius || 'inherit', ";color:").concat(theme.inlineColor || 'inherit', ";cursor:text;margin:0 0.1875rem 0.1875rem}\n\n.dmMja_eXrk.dmMja_EwaR:before{border-radius:calc(").concat(theme.inlineBorderRadius || 'inherit', "*1.5)}\n\n.dmMja_eXrk.dmMja_EwaR:hover{background-color:").concat(theme.inlineBackgroundHover || 'inherit', "}\n\n.dmMja_eXrk.dmMja_erdA .dmMja_dnnz{background-color:").concat(theme.inlineIconColor || 'inherit', ";border-radius:50%;color:").concat(theme.inlineBackground || 'inherit', ";font-size:0.75rem;inset-inline-end:0;inset-inline-start:auto;padding:0.25rem;position:absolute;top:0;transform:translate(40%,-40%)}\n\n[dir=ltr] .dmMja_eXrk.dmMja_erdA .dmMja_dnnz{left:auto;right:0}\n\n[dir=rtl] .dmMja_eXrk.dmMja_erdA .dmMja_dnnz{left:0;right:auto}\n\n.dmMja_eXrk.dmMja_erdA:hover .dmMja_dnnz{background-color:").concat(theme.inlineIconHoverColor || 'inherit', "}\n\n[dir=rtl] .dmMja_eXrk.dmMja_erdA .dmMja_dnnz{transform:translate(-40%,-40%)}");
  },
  'root': 'dmMja_bGBk',
  'small': 'dmMja_doqw',
  'icon': 'dmMja_dnnz',
  'medium': 'dmMja_ycrn',
  'large': 'dmMja_cMDj',
  'button': 'dmMja_EwaR',
  'dismissible': 'dmMja_erdA',
  'disabled': 'dmMja_ywdX',
  'text': 'dmMja_eWKC',
  'default': 'dmMja_ddES',
  'inline': 'dmMja_eXrk'
};

/**
---
category: components
---
**/
var Tag = (_dec = (0, _uiTestable.default)(), _dec2 = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = _dec2(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Tag, _Component);

  function Tag() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Tag);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Tag)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.focus = function () {
      _this._container && _this._container.focus();
    };

    _this.handleClick = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          onClick = _this$props.onClick;

      if (disabled || readOnly) {
        e.preventDefault();
        e.stopPropagation();
      } else if (typeof onClick === 'function') {
        onClick(e);
      }
    };

    _this.handleRef = function (node) {
      _this._container = node;
    };

    return _this;
  }

  (0, _createClass2.default)(Tag, [{
    key: "render",
    value: function render() {
      var _classes;

      var _this$props2 = this.props,
          className = _this$props2.className,
          dismissible = _this$props2.dismissible,
          disabled = _this$props2.disabled,
          readOnly = _this$props2.readOnly,
          size = _this$props2.size,
          text = _this$props2.text,
          title = _this$props2.title,
          onClick = _this$props2.onClick,
          margin = _this$props2.margin,
          variant = _this$props2.variant;
      var classes = (_classes = {}, (0, _defineProperty2.default)(_classes, styles.root, true), (0, _defineProperty2.default)(_classes, styles[variant], true), (0, _defineProperty2.default)(_classes, styles[size], size), (0, _defineProperty2.default)(_classes, styles.dismissible, dismissible), (0, _defineProperty2.default)(_classes, styles.button, onClick), (0, _defineProperty2.default)(_classes, styles.disabled, disabled), _classes);

      var passthroughProps = _View.default.omitViewProps((0, _passthroughProps.omitProps)(this.props, Tag.propTypes), Tag);

      return _react.default.createElement(_View.default, Object.assign({}, passthroughProps, {
        ref: this.handleRef,
        elementRef: this.props.elementRef,
        className: (0, _classnames.default)(className, classes),
        as: onClick ? 'button' : 'span',
        margin: margin,
        type: onClick ? 'button' : null,
        onClick: onClick ? this.handleClick : null,
        disabled: disabled || readOnly,
        display: null,
        title: title || (typeof text === 'string' ? text : null)
      }), _react.default.createElement("span", {
        className: styles.text
      }, text), onClick && dismissible ? _react.default.createElement(_IconX.default, {
        className: styles.icon
      }) : null);
    }
  }, {
    key: "focused",
    get: function get() {
      return (0, _isActiveElement.default)(this._container);
    }
  }]);
  Tag.displayName = "Tag";
  return Tag;
}(_react.Component), _class2.propTypes = {
  className: _propTypes.default.string,
  text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  title: _propTypes.default.string,

  /**
   * Whether or not to disable the tag
   */
  disabled: _propTypes.default.bool,

  /**
   * Works just like disabled but keeps the same styles as if it were active
   */
  readOnly: _propTypes.default.bool,
  dismissible: _propTypes.default.bool,

  /**
  * Valid values are `0`, `none`, `auto`, `xxxx-small`, `xx-small`, `x-small`,
  * `small`, `medium`, `large`, `x-large`, `xx-large`. Apply these values via
  * familiar CSS-like shorthand. For example: `margin="small auto large"`.
  */
  margin: _ThemeablePropTypes.default.spacing,

  /**
  * If you add an onClick prop, Tag renders as a clickable button
  */
  onClick: _propTypes.default.func,

  /**
  * Provides a reference to the underlying html root element
  */
  elementRef: _propTypes.default.func,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  variant: _propTypes.default.oneOf(['default', 'inline'])
}, _class2.defaultProps = {
  size: 'medium',
  dismissible: false,
  variant: 'default',
  elementRef: void 0,
  className: void 0,
  title: void 0,
  disabled: false,
  readOnly: false,
  margin: void 0,
  onClick: void 0
}, _temp)) || _class) || _class);
var _default = Tag;
exports.default = _default;